// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","542":"component---src-pages-news-[id]-tsx"}[chunkId] || chunkId) + "-" + {"245":"104b077cd4aa2d515e61","453":"25010406e28e7336cc20","522":"e290f619806f7de89bb4","542":"2f4e64d27727a9581f52","577":"d795738dd10c9f932d47"}[chunkId] + ".js";
};